import { render, staticRenderFns } from "./ListWidgets.vue?vue&type=template&id=a7672ad0&"
import script from "./ListWidgets.vue?vue&type=script&lang=js&"
export * from "./ListWidgets.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports